import React from 'react';

export const Events = () => {
  const events = [
    { icon: '🔥', title: 'Faith Conference', time: 'Date to be announced', desc: 'A powerful time of faith building and impartation.' },
    { icon: '❤️', title: 'Love Feast', time: 'Date to be announced', desc: "Celebrating God's love and fellowship." },
    { icon: '📖', title: 'Global Bible Study', time: 'Every Wednesday @ 6:00 PM', desc: 'Deep dive into the Word of God.' },
    { icon: '📢', title: 'Evangelism', time: 'Weekly', desc: 'Reaching out to the lost with the Gospel.' },
    { icon: '🏠', title: 'Cell Meetings', time: 'Weekly', desc: 'Small group fellowship and discipleship.' }
  ];

  return (
    <section id="events" className="section-padding bg-accent">
      <div className="container-custom">
        <div className="text-center mb-24">
          <p className="text-primary font-bold tracking-[0.3em] uppercase text-xs mb-6">Stay Connected</p>
          <h2 className="text-4xl sm:text-6xl font-bold mb-8">Upcoming Events</h2>
          <p className="text-lg text-secondary/60 max-w-2xl mx-auto">
            Join us in our upcoming programs and grow together in faith and fellowship.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {events.map((event, index) => (
            <article key={index} className="group p-8 rounded-[2.5rem] bg-white border border-secondary/5 hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
              <div className="w-14 h-14 bg-accent rounded-2xl flex items-center justify-center mb-8 group-hover:bg-primary transition-colors duration-500" aria-hidden="true">
                <span className="text-2xl group-hover:scale-110 transition-transform">{event.icon}</span>
              </div>
              <h3 className="text-2xl font-bold mb-2">{event.title}</h3>
              <p className="text-primary font-bold text-xs tracking-widest uppercase mb-4">{event.time}</p>
              <p className="text-secondary/60 text-sm leading-relaxed">{event.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-24 text-center">
          <div className="inline-block p-10 sm:p-12 rounded-[3rem] bg-secondary text-white relative overflow-hidden max-w-3xl">
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/10 rounded-bl-full"></div>
            <p className="relative z-10 text-lg sm:text-xl text-white/80 leading-relaxed">
              "For where two or three are gathered together in my name, there am I in the midst of them." <br />
              <span className="text-primary font-bold mt-4 block">- Matthew 18:20</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
